import StudioCardHoverMedia from './StudioCardHoverMedia';
import StudioCardImage from './StudioCardImage';
import { getStudioGridOptionLabel } from '../utils/studioGridOptionLabel';
import { useCardPressHoldVideo } from '../hooks/useCardPressHoldVideo';
import {
	EthnicityCard,
	OptionGridStage as OptionGrid,
	StudioCardImageSlot,
} from '../studio.styles';

const STAGE_OBJECT_POSITION = {
	eyecolor: 'center center',
};

const OptionGridStage = ({
	lang,
	stepKey,
	gender,
	options,
	selectedLabel,
	onSelect,
	ariaLabel,
	gridOptionLabels,
}) => {
	if (!options?.length) return null;

	const { isCardActive, getCardVideoProps } = useCardPressHoldVideo();
	const objectPosition = STAGE_OBJECT_POSITION[stepKey] ?? 'center top';

	return (
		<OptionGrid
			data-studio-panel={stepKey}
			$gender={gender}
			$stage={stepKey}
			aria-label={ariaLabel}
		>
			{options.map((opt) => {
				const displayLabel = getStudioGridOptionLabel(
					opt.label,
					gridOptionLabels,
					lang,
				);
				const cardVideoProps = opt.video ? getCardVideoProps(opt.label) : {};

				return (
					<EthnicityCard
						key={opt.label}
						type="button"
						$selected={selectedLabel === opt.label}
						$dimmed={Boolean(selectedLabel) && selectedLabel !== opt.label}
						aria-label={displayLabel}
						aria-pressed={selectedLabel === opt.label}
						onClick={() => onSelect(stepKey, opt.label)}
						{...cardVideoProps}
					>
						<StudioCardImageSlot>
							{opt.video ? (
								<StudioCardHoverMedia
									imageSrc={opt.image}
									videoSrc={opt.video}
									alt={displayLabel}
									objectPosition={objectPosition}
									isActive={isCardActive(opt.label)}
								/>
							) : (
								<StudioCardImage
									src={opt.image}
									alt={displayLabel}
									objectPosition={objectPosition}
								/>
							)}
						</StudioCardImageSlot>
						<span>{displayLabel}</span>
					</EthnicityCard>
				);
			})}
		</OptionGrid>
	);
};

export default OptionGridStage;
